<template>
  <section class="contract-payment-methods">
    <h5>Способы оплаты</h5>
    <!-- FDO -->
    <ul v-if="isDistance" class="contract-payment-methods__list">
      <contract-payment-method title="Оплата через Сбербанк-онлайн по платежному коду">
        <p>При оплате через Сбербанк онлайн (web-версия и мобильное приложение) комиссия составляет 1% от суммы платежа. Максимальный размер комиссии 500 руб.</p>
        <p>При наличии подписок СБЕРПРАЙМ и СБЕРПРАЙМ+ без комиссии (в рамках лимитов).</p>
        <a href="https://storage.tusur.ru/files/189813/2026-instruktsiya-platezhnii-kod.pdf" target="_blank" rel="noopener noreferrer">Инструкция</a>
      </contract-payment-method>
      <contract-payment-method title="Оплата через Сбербанк-онлайн по QR-коду">
        <p>При оплате через Сбербанк онлайн (web-версия и мобильное приложение) комиссия составляет 1% от суммы платежа. Максимальный размер комиссии 500 руб.</p>
        <p>При наличии подписок СБЕРПРАЙМ и СБЕРПРАЙМ+ без комиссии (в рамках лимитов).</p>
        <a href="https://storage.tusur.ru/files/189814/2026-instruktsiya-qr-kod.pdf" target="_blank" rel="noopener noreferrer">Инструкция</a>
        <div v-if="qrCode" class="contract-payment-methods__qr">
          <h6>Ваш QR-код</h6>
          <div v-html="qrCode"></div>
        </div>
      </contract-payment-method>
      <contract-payment-method title="Оплата по банковским реквизитам">
        <p>
          Перечислением через любой банк на расчетный счет ТУСУРа
          (<a href="https://tusur.ru/ru/o-tusure/kontakty-i-rekvizity" target="_blank" rel="noopener noreferrer">реквизиты для оплаты</a>).
        </p>
        <a v-if="false" href="https://storage.tusur.ru/files/189812/2026-instruktsiya-rekviziti.pdf" target="_blank" rel="noopener noreferrer">Инструкция</a>
      </contract-payment-method>
      <contract-payment-method title="Оплата по квитанции об оплате">
        <p>Скачайте квитанцию в разделе «Документы», распечатайте её и оплатите в любом отделении банка или почты России.</p>
      </contract-payment-method>
    </ul>

    <!-- NO FDO -->
    <ul v-else class="contract-payment-methods__list">
      <contract-payment-method title="Оплата в Кабинете ТУСУР через сервис онлайн-оплаты">
        <p>
          Перейдите в Кабинет ТУСУРа в сервис
          <a href="https://profile.tusur.ru/payments" target="_blank" rel="noopener noreferrer">онлайн-оплаты</a>.
        </p>
        <p>Оплата услуг осуществляется с помощью банковских карт платёжных систем МИР, VISA International, Mastercard Worldwide или JCB.</p>
        <p>Комиссия не взимается.</p>
      </contract-payment-method>
      <contract-payment-method title="Оплата по банковским реквизитам">
        <p>
          Перечислением через любой банк на расчетный счет ТУСУРа
          (<a href="https://tusur.ru/ru/o-tusure/kontakty-i-rekvizity" target="_blank" rel="noopener noreferrer">реквизиты для оплаты</a>).
        </p>
        <a v-if="false" href="https://storage.tusur.ru/files/189812/2026-instruktsiya-rekviziti.pdf" target="_blank" rel="noopener noreferrer">Инструкция</a>
      </contract-payment-method>
      <contract-payment-method title="Оплата через кассу ТУСУРа">
        <p>Обратитесь в кассу ТУСУРа по адресу: г. Томск, пр. Ленина, 40, главный корпус. На территории университета действует пропускной режим, вход в корпус осуществляется при предъявлении документа, удостоверяющего личность.</p>
        <p>График работы кассы: пн–чт с 9:00 до 17:30, пт с 9:00 до 16:30, обеденный перерыв с 13:00 до 14:00.</p>
      </contract-payment-method>
    </ul>
  </section>
</template>

<script setup>
import ContractPaymentMethod from './ContractPaymentMethod.vue'

defineProps({
  isDistance: { type: Boolean, default: false },
  qrCode: String,
})
</script>
